var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"Summary",staticClass:"visual-block-step step-4-visual-block pa-6 mt-8 mb-12",class:{ 'active-step' : _vm.isActiveStep}},[_c('CurrentSelectionListVisual')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }